<template>
  <section class="section home-insurance">
    <div class="section-inner">
      <div class="news-layout">
        <aside class="news-aside">
          <h2 class="section-title">保险信息</h2>
          <p class="section-subtitle">分享保险行业信息及各保险公司的产品信息</p>
          <button class="btn-primary" @click="goMore">查看更多</button>
        </aside>
        <div class="news-list">
          <article
            v-for="item in latestItems"
            :key="item.id"
            class="news-item"
            @click="goDetail(item.id)"
          >
            <div class="news-icon">
              <img v-if="item.icon" :src="item.icon" :alt="item.title">
              <span v-else class="news-icon-fallback" aria-hidden="true"></span>
            </div>
            <div class="news-main">
              <h3 class="news-title">{{ item.title }}</h3>
              <div class="news-meta">
                <span>{{ item.date }}</span>
                <span>· {{ item.author }}</span>
              </div>
              <p class="news-summary">{{ item.summary }}</p>
            </div>
          </article>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'HomeInsurance',
  computed: {
    ...mapGetters(['getInsuranceList']),
    latestItems() {
      return (this.getInsuranceList || []).slice(0, 3)
    }
  },
  methods: {
    goDetail(id) {
      this.$router.push(`/insurance/${id}`)
    },
    goMore() {
      this.$router.push('/insurance')
    }
  }
}
</script>

<style scoped>
.home-insurance {
  background: #ffffff;
}

.news-layout {
  display: grid;
  grid-template-columns: 260px minmax(0, 1fr);
  gap: 36px;
  align-items: start;
}

.news-aside .section-subtitle {
  margin-bottom: 20px;
}

.news-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.news-item {
  display: grid;
  grid-template-columns: 52px minmax(0, 1fr);
  gap: 14px;
  padding: 16px 18px;
  border-radius: 14px;
  background: #f8fafc;
  cursor: pointer;
  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.06);
  transition: transform 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease;
}

.news-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.14);
  background-color: #ffffff;
}

.news-icon {
  width: 52px;
  height: 52px;
  border-radius: 12px;
  overflow: hidden;
  background: #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.news-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.news-icon-fallback {
  width: 22px;
  height: 22px;
  border-radius: 6px;
  background: linear-gradient(135deg, #94a3b8, #64748b);
}

.news-title {
  font-size: 17px;
  color: #102a43;
  margin-bottom: 6px;
  font-weight: 700;
}

.news-meta {
  font-size: 12px;
  color: #9fb3c8;
  margin-bottom: 8px;
}

.news-summary {
  font-size: 14px;
  color: #52606d;
  line-height: 1.7;
}

@media (max-width: 768px) {
  .news-layout {
    grid-template-columns: 1fr;
    gap: 18px;
  }
}
</style>
